import { render } from "./AdminPermissionDefinitions.vue?vue&type=template&id=8e9019c8"
import script from "./AdminPermissionDefinitions.vue?vue&type=script&lang=js"
export * from "./AdminPermissionDefinitions.vue?vue&type=script&lang=js"

import "./AdminPermissionDefinitions.vue?vue&type=style&index=0&id=8e9019c8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__